// validation.js

export const validateField = (name, value, formData = {}) => {
    if(name === 'dependentFields'){
        return [];
    }


    const errors = [];
    console.log('Validating field: ' + name);
    console.log('Validating formData: ');
    console.log(formData);

    // Required field validation
    if (!value && value !== 0 && isFieldRequired(name, formData)) {
        console.log(name);
        console.log('No Value');
        console.log(formData);
        errors.push(`${getFieldLabel(name)} is required`);
        return errors;
    }

    // Phone number validation
    if (name.includes('phone') && value && value.required === true) {
        if (!value.match(/^\d{3}-\d{3}-\d{4}$/)) {
            errors.push('Please enter a valid phone number (XXX-XXX-XXXX)');
        }
    }

    // SSN validation
    if (name.includes('ssn') && value) {
        if (!value.match(/^\d{3}-\d{2}-\d{4}$/)) {
            errors.push('Please enter a valid SSN (XXX-XX-XXXX)');
        }
    }

    // Email validation
    if (name.includes('email') && value) {
        if (!value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            errors.push('Please enter a valid email address');
        }
    }

    // Routing number validation
    if (name === 'rt_number' && value) {
        if (!value.match(/^\d{9}$/)) {
            errors.push('Bank routing number must be exactly 9 digits');
        }
    }

    // Account number validation
    if (name === 'act_number' && value) {
        if (!value.match(/^\d+$/)) {
            errors.push('Bank account number must contain only numbers');
        }
    }

    // Date validations
    if (name.includes('dob') && value) {
        const date = new Date(value);
        const today = new Date();
        if (date > today) {
            errors.push('Date of birth cannot be in the future');
        }
    }

    // Dependent-specific validations
    /*if (name.includes('dependent')) {
        if (formData.dependents === 'have_dependents') {
            // Add dependent-specific validations
        }
    }*/

    return errors;
};

export const validateForm = (formData, dependents, formFields) => {
    const errors = {};

    // Helper function to check if a field should be shown
    const isFieldVisible = (fieldKey, field, sectionKey) => {
        // Check section visibility first
        const section = formFields[sectionKey];
        if (section.showIf && !section.showIf(formData)) {
            return false;
        }

        // Then check individual field visibility
        if (field.showIf && !field.showIf(formData)) {
            return false;
        }

        return true;
    };

    // Validate all visible form fields
    Object.entries(formFields).forEach(([sectionKey, section]) => {
        Object.entries(section.fields).forEach(([fieldKey, field]) => {
            // Only validate if the field should be visible
            if (isFieldVisible(fieldKey, field, sectionKey) && field.required === true) {
                const fieldErrors = validateField(fieldKey, formData[fieldKey], formData);
                if (fieldErrors.length > 0) {
                    errors[fieldKey] = fieldErrors;
                }
            }
        });
    });

    // Validate dependents if they exist and should be shown
    if (formData.dependents === 'have_dependents' && dependents.length > 0) {
        const dependentErrors = [];
        dependents.forEach((dependent, index) => {
            const depErrors = {};
            Object.keys(dependent).forEach(field => {
                const fieldErrors = validateField(field, dependent[field], formData);
                if (fieldErrors.length > 0) {
                    depErrors[field] = fieldErrors;
                }
            });
            if (Object.keys(depErrors).length > 0) {
                dependentErrors[index] = depErrors;
            }
        });
        if (dependentErrors.length > 0) {
            errors.dependents = dependentErrors;
        }
    }

    return errors;
};

export const isFieldRequired = (name, formData) => {
    // Define conditions for when fields are required based on other field values
    const conditionalRequirements = {
        spouse_name: () => ['Married Filing Joint Return', 'Married Filing Seperately'].includes(formData.filling_status),
        spouse_ssn: () => ['Married Filing Joint Return', 'Married Filing Seperately'].includes(formData.filling_status),
        spouse_dob: () => ['Married Filing Joint Return', 'Married Filing Seperately'].includes(formData.filling_status),
        spouse_email: () => ['Married Filing Joint Return', 'Married Filing Seperately'].includes(formData.filling_status),
        spouse_occupation: () => ['Married Filing Joint Return', 'Married Filing Seperately'].includes(formData.filling_status),
        st_return: () => formData.state_return === 'yes_state_return',
        referral: () => formData.hear_aboutus === 'referral_hear',
    };

    return conditionalRequirements[name] ? conditionalRequirements[name]() : true;
};

export const getFieldLabel = (name) => {
    const labels = {
        name: 'Username',
        account_type: 'Account Type',
        ssn_id: 'SSN/Tax ID',
        client: 'Full Name',
        contact_primary: 'Primary Contact',
        client_dob: 'Date of Birth',
        phone_primary: 'Client Phone',
        phone_secondary: 'Alternate Phone',
        email: 'Client Email',
        address: 'Mailing Address',
        occupation: 'Type of Business',
        filling_status: 'Filing Status',
        dependents: 'Do you have dependents?',
        state_return: 'Will you be filing a state return?',
        st_return: 'Select State',
        spouse_name: 'Spouse\'s Name',
        spouse_dob: 'Spouse DOB',
        spouse_ssn: 'Spouse SSN',
        spouse_email: 'Spouse Email',
        spouse_occupation: 'Spouse Occupation',
        rt_number: 'Bank Routing #',
        act_number: 'Account #',
        bank_name: 'Bank Name',
        new_client: 'Are You A New Client This Year?',
        hear_aboutus: 'How did you hear about us?',
        referral: 'Referral Name',
        document_copies: 'Document Delivery Preference',
        preferred_preparer: 'Preferred Preparer'
    };

    return labels[name] || name.split('_').map(word =>
                                                   word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
};
